export const constraints = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
  },
};
